import React from 'react'
import { connect } from 'react-redux'
import {
  changeGMAAnswer,
  getGMAQuestion,
  getGMA,
  finishGMA,
} from '../../../../ducks/respondent'
import SwipePage from 'components/common/SwipePage'
import styles from './AbilityQuestion.module.scss'
import Cell from '../../Cell.js'
import Matrix from '../../Matrix.js'
import ss from 'seededshuffle'
import { QuestionContainer } from 'components/shared/QuestionContainer/QuestionContainer'
import {
  nextPage,
  previousPage,
  nextUnanswered,
  toGmaQuiz,
} from 'ducks/router'

const AbilityQuestion = ({
  question,
  value,
  changeGMAAnswer,
  respondentId,
  finished,
  totalQuestions,
  answered,
  nextPage,
  previousPage,
  nextUnanswered,
  answers,
  finishGMA,
}) => {
  const seed = respondentId[respondentId.length - 1].charCodeAt(0)
  const options = ss.shuffle([...'abcdef'], seed + question, true)
  const clickHandler = letter => e =>
    changeGMAAnswer({ key: question, value: value === letter ? null : letter })

  const questionIndex =
    Object.keys(answers).findIndex(key => key === question) + 1

  return (
    <QuestionContainer
      {...{
        questionIndex,
        totalQuestions,
        finished,
        previousPage,
        answered,
        nextUnanswered,
        nextPage,
      }}
      finishTest={() => finishGMA({ reason: 'click button' })}
    >
      <SwipePage slideSpeed={500} routeAction={toGmaQuiz}>
        <div className={styles.questionWrapper}>
          <div className={styles.question}>
            <Matrix columns={3} grid>
              {[...'12345678', value].map(q => (
                <Cell key={q} question={question} value={q} />
              ))}
            </Matrix>
          </div>
          <div className={styles.options}>
            <Matrix columns={3}>
              {options.map(letter => (
                <Cell
                  key={letter}
                  option={true}
                  selected={value === letter}
                  value={letter}
                  question={question}
                  onClick={clickHandler(letter)}
                />
              ))}
            </Matrix>
          </div>
        </div>
      </SwipePage>
    </QuestionContainer>
  )
}

const mapStateToProps = state => {
  const { value } = getGMAQuestion()(state)
  const { totalQuestions, totalAnswers } = getGMA(state)
  const finished = totalQuestions - totalAnswers === 0

  return {
    respondentId: state.respondent.id,
    answers: state.respondent.gma.answers,
    finished,
    totalQuestions,
    answered: value !== null,
    ...getGMAQuestion()(state),
  }
}

const mapDispatchToProps = {
  changeGMAAnswer,
  nextPage,
  previousPage,
  nextUnanswered,
  finishGMA,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AbilityQuestion)
